import { makeStyles } from '@mui/styles';
import { AppTheme } from '../../../theme/useTheme';

export const useStyles = makeStyles((theme: AppTheme) => ({
  '@global': {
    html: {
      backgroundColor: theme.palette.background.default,
      height: '100%',
    },
    body: {
      margin: 0,
      height: '100%',
    },
    '#root': {
      height: '100%',
    },
  },
  heading: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(3),
    textAlign: 'center',
    fontSize: '20px',
  },
  container: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    'flex-direction': 'column',
    height: '100%',
    marginTop: 'auto',
    justifyContent: 'center',
  },
  button: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    color: theme.palette.primary[500],
    padding: '11px 12px',
    border: '2px solid',
    lineHeight: '28px',
    borderRadius: '5em',
    borderColor: theme.palette.primary[500],
    marginBottom: '20px',
    marginLeft: '20px',
    marginRight: '20px',
  },
}));
